import { Autocomplete, Chip, TextField } from "@mui/material"
import { useState } from "react"

export type TagValuesAutocompleteProps = {
  value: string[]
  onChange: (value: string[]) => void
}

export const TagValuesAutocomplete = ({ value, onChange }: TagValuesAutocompleteProps) => {
  const [inputValue, setInputValue] = useState("")

  const handleBlur = () => {
    const trimmedValue = inputValue.trim()
    if (!trimmedValue) return

    if (!value.includes(trimmedValue)) onChange([...value, trimmedValue])
    setInputValue("")
  }

  return (
    <Autocomplete<string, true, false, true>
      multiple
      freeSolo
      fullWidth
      options={[]}
      value={value}
      inputValue={inputValue}
      onInputChange={(_, newInputValue) => setInputValue(newInputValue)}
      onChange={(_, newValue) => onChange(newValue)}
      // allow adding tags on hitting enter or blurring the input field
      onBlur={handleBlur}
      renderTags={(tagsValue, getTagProps) =>
        tagsValue.map((option, tagIndex) => {
          const { key, ...tagProps } = getTagProps({ index: tagIndex })
          return <Chip key={key} label={option} size="small" {...tagProps} />
        })
      }
      renderInput={(params) => <TextField {...params} placeholder="Add value" size="small" />}
      size="small"
    />
  )
}

export default TagValuesAutocomplete
